import { contra_turno } from "./contra-turno";
import { escolas_sem_continuidade } from "./escolas-sem-continuidade";
import { relatorio_escolas_sem_continuidade } from "./relatorio-escolas-sem-continuidade";
import { sem_continuidade } from "./sem-continuidade";

const cargas_escolas = [
  contra_turno,
  sem_continuidade,
  escolas_sem_continuidade,
  relatorio_escolas_sem_continuidade,
];

export { cargas_escolas };
